import React, { useEffect } from 'react';
import { Fees } from './Fees';
import { ErrorMessage, SpaceWrapper } from 'ui-toolkit';
import { useParams } from 'react-router-dom';
import { useKeyToSelect } from '../../../store/createKeyedDataAsyncSlice';
import { RootStore } from '../../../store/types';
import { getClientOrderAction } from '../../../store/clientPortal/clientOrderSlice';
import { ClientOrderHeaderContainer } from '../clientOrderHeader/ClientOrderHeaderContainer';
import { useAppDispatch } from '../../../store/store';

export const ClientFeesTab: React.FC = () => {
  const dispatch = useAppDispatch();
  const { orderId } = useParams<{ orderId: string }>();

  const { data: orderData, fetchError } = useKeyToSelect(
    orderId,
    ({ clientPortal }: RootStore) => clientPortal.clientOrder
  );

  useEffect(() => {
    dispatch(getClientOrderAction(orderId));
  }, [orderId, dispatch]);

  return (
    <>
      {orderData && (
        <>
          <ErrorMessage error={fetchError} />
          <ClientOrderHeaderContainer />
          <SpaceWrapper>
            <Fees fees={orderData.fees} transactionCategory={orderData.transactionCategory} />
          </SpaceWrapper>
        </>
      )}
    </>
  );
};
